export default {
  PAYMENT_TYPE_CASH: 'CASH',
  PAYMENT_TYPE_CARD: 'CARD',
  PAYMENT_TYPE_VOUCHER: 'VCHR',
};
